import { buildUseT } from '@guiker/react-framework'

export const useT = buildUseT({ domain: 'propertySale' })
